var _polygon, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "black",
    points: "150,18 244, 182 56, 182"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 135,
    fontSize: 45,
    textAnchor: "middle",
    fill: "hotpink"
  }, "MAM")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMaker);
export default __webpack_public_path__ + "static/media/logo-maker.24ed7236dc603bf6fe1734995f218515.svg";
export { ForwardRef as ReactComponent };